module.exports = __webpack_public_path__ + "static/media/campaign-address.056857b6.svg";